import { render } from "./DotsRowIcon.vue?vue&type=template&id=77cb2e58"
const script = {}
script.render = render

export default script